import React from "react";
import { Box, Typography } from "@mui/material";
import AgentMarkdownMessage from "../common/AgentMarkdownMessage";

interface DocumentMarkdownPreviewProps {
  content?: string | null;
}

const DocumentMarkdownPreview: React.FC<DocumentMarkdownPreviewProps> = ({
  content,
}) => {
  if (!content?.trim()) {
    return (
      <Typography variant="body2" color="text.secondary" fontStyle="italic">
        No document content.
      </Typography>
    );
  }

  return (
    <Box
      sx={{
        p: 2,
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 1,
        bgcolor: "background.paper",
        maxHeight: "60vh",
        overflow: "auto",
      }}
    >
      <AgentMarkdownMessage content={content} />
    </Box>
  );
};

export default DocumentMarkdownPreview;
